import React from 'react';
import packageJson from '../../package.json';
global.appVersion = packageJson.version;

const clearCache = () => {
  // So recarrega uma vez por sessao do navegador - se depois de recarregar a versao ainda
  // divergir (ex: algum cache intermediario, fora do navegador, servindo o meta.json antigo),
  // evita ficar recarregando para sempre.
  if (sessionStorage.getItem('cacheBusterReloaded')) {
    return;
  }
  sessionStorage.setItem('cacheBusterReloaded', '1');
  // deleta cache e recarrega página
  window.location.reload(true);
}

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      serverVersion: '',
      clientVersion: '',
      checkReloading: () => {
        fetch('/meta.json', { cache: 'no-store' })
          .then((response) => response.json())
          .then((meta) => {
            const latestVersion = meta.version;
            const currentVersion = global.appVersion;
            
            this.serverVersion =  meta.version;
            this.clientVersion = global.appVersion;

            //alert(`meta.version => v ${meta.version} - global.appVersion => v ${global.appVersion}`);
            // console.log(`server version => v ${meta.version} - client appVersion => v ${global.appVersion}`)
            if (meta.version != global.appVersion) {
              clearCache();    
            }
          });
      }
    };
  }

  render() {
    const { loading, isLatestVersion, serverVersion, clientVersion, checkReloading } = this.state;
    return this.props.children({ loading, isLatestVersion, serverVersion, clientVersion, checkReloading });
  }
}

export default CacheBuster;